import { Component } from '@angular/core';

import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';

import { ContainerBase } from '../../../core/base/container-base';
import { UXPage } from '../../../core/models/ux-page';

import * as fromBase from '../../../base/reducers'
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss']
})
export class PageContainerComponent extends ContainerBase {
  currentPage$: Observable<UXPage>;

  constructor(
    private store: Store<fromBase.State>
  ) {
    super()

    this.currentPage$ = this.store.pipe(
      select(fromBase.getCurrentPage),
      takeUntil(this.destroyed$)
    )


   }
}
